import {
	VersionTermConfigEntity,
} from 'Models/Entities';
import {
	indexByProperty,
} from 'Util/DataIndexUtils';
import {
	StudyLoadConfig, TermIndex, YearHalf,
} from 'Queries/Hooks/StudyPlan/types';

export const generatePeriodDefaultLoad = (
	period: YearHalf,
	defaultTermConfig: VersionTermConfigEntity[] | undefined,
) => {
	const termsForPeriod = defaultTermConfig?.filter(termConfig => (
		termConfig.term?.studyPeriod?.order === period
	)) || [];
	const termsForPeriodIndexedByOrder = indexByProperty(termsForPeriod, termConfig => termConfig.term.order);
	const defaultPeriodLoads: number[] = [];

	for (const currentIndex in TermIndex) {
		if (typeof parseInt(currentIndex, 10) === 'number') {
			const termDefaultLoad = termsForPeriodIndexedByOrder[currentIndex]?.defaultLoad;
			defaultPeriodLoads[currentIndex] = termDefaultLoad || 0;
		}
	}

	return defaultPeriodLoads;
};

/**
 * Set all study load for all terms in years preceding and including
 * the specificed year, if they have yet to be provisioned a study load
 *
 * @param planLoadConfig
 * the config to modify
 *
 * @param referenceYear
 * the reference year to count backwards from, inclusive
 */
export const populateStudyLoad = (
	planLoadConfig: StudyLoadConfig,
	referenceYear: number,
	defaultTermConfig: VersionTermConfigEntity[] | undefined,
) => {
	// populate modified year and previous unmodified years with default load
	for (let currentYear = referenceYear; currentYear >= 0; currentYear -= 1) {
		// if current iterated year does not have load set, set it to default load
		if (!planLoadConfig[currentYear]) {
			planLoadConfig[currentYear] = [
				[...generatePeriodDefaultLoad(0, defaultTermConfig)],
				[...generatePeriodDefaultLoad(1, defaultTermConfig)],
			];
		}
	}

	return planLoadConfig;
};
